/**
 * ============================================================================
 *  File        : frontend/src/components/ui/sonner.tsx
 *  Module      : components::ui
 *  Purpose     : shadcn/ui toast — Sonner Toaster + re-export toast()
 *  Author      : EF Engineering
 *  Created     : 2026-05-31
 *  Updated     : 2026-05-31
 *  License     : Proprietary - ECO FAITH Platform v3.0
 * ============================================================================
 */

import { Toaster as Sonner, type ToasterProps } from 'sonner'
import type { ReactElement } from 'react'

export function Toaster(props: ToasterProps): ReactElement {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { toast } from 'sonner'
